import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import { Button, Grid, TextField, CircularProgress, Tooltip, Drawer } from '@material-ui/core';
import { LabelValueCard, RevisionHistory, PageLoader, DeletePopUp, CustomChip, CustomDropzone, PreviewDocsModal } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { assetId } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus, checkPermission, downloadFile, toastFlashMessage } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addLatePaymentApi, getLatePaymentApi } from '../apiServices';
import { addLatePayment, errorCode } from '..';
import { globalDeleteService, globalPostService } from '../../../../utils_v2/globalApiServices';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
import { Autocomplete } from '@material-ui/lab';
import { regexConstants } from '../../../../constants/regEx';

class LatePaymentCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      late_payment: {},
      error: {},
      previewDocs: '',
      deleteAttachmentModal: false,
      deleteItem: null,
      attachedDoc: []
    }
    this.addLatePaymentApi = addLatePaymentApi.bind(this);
    this.getLatePaymentApi = getLatePaymentApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      late_payment: {
        ...prevState.late_payment,
        [keyParam]: data
      }
    }))
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  addAttachment = (data) => {
    const { props, params } = this.props;
    const { attachedDoc, late_payment } = this.state;
    let formdata = new FormData();

    attachedDoc.forEach(item => {
      formdata.append('files', item);
    });

    formdata.append('asset_type', assetId[params?.type])
    formdata.append('asset_slug', params.aircraft_slug);
    formdata.append('contract_slug', params.contract_slug);
    formdata.append('model_type', '11');
    formdata.append('object_id', data?.data?.id)
    this.setState({ pageLoader: true });
    globalPostService(`contracts/attachments/`, formdata)
      .then(response => {
        if (response.data.statusCode === 200) {
          this.props.getResponseBack();
          toastFlashMessage(data?.message, 'success');
        } else {
          toastFlashMessage(response.data.message, 'error');
        }
        this.setState({ pageLoader: false });
      });
  }
  addEditRelatedLoanFn = () => {
    const { late_payment } = this.state;
        let validationInputs = {
          name:errorCode['name'][fieldValidation({...errorCode['latepaymentObj'], fieldval: late_payment?.name })],
        };
        if (late_payment?.margin && parseFloat(late_payment.margin) > 100) {
          validationInputs.margin = 'Margin cannot be greater than 100%';
        }    
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length + late_payment?.attachments?.length > 50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      this.setState({ formSubmitLoader: true });
      this.addLatePaymentApi(this.props, late_payment)
        .then(response => {
          this.setState({ formSubmitLoader: false });
          if (checkApiStatus(response)) {
            if (this.state.attachedDoc?.length) {
              addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "24", this.toggleFnc);
              this.setState({ modal: false, mode: '', late_payment: {}, error: {} });
            } else {
              this.props.getResponseBack();
              this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
              this.setState({ modal: false, mode: '', late_payment: {}, error: {} });
            }

          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
      }else{
        this.setState({error: validationInputs});
      }
    }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };

  deleteAttachment = (item) => {
    const { late_payment, deleteItem } = this.state;
    this.setState({ deleteAttachmentModal: false, pageLoader: true });
    globalDeleteService(`contracts/attachments/${deleteItem.uuid}/`)
      .then((response) => {
        this.setState({ pageLoader: false });
        if (response?.data?.statusCode === 200) {
          const updatedAttachment = late_payment.attachments.filter((file) => file.uuid !== deleteItem.uuid);
          this.setState({ late_payment: { ...late_payment, attachments: updatedAttachment } });
          this.getLatePaymentApi(this.props, late_payment.id)
          toastFlashMessage(response?.data?.message, 'success');
        } else {
          toastFlashMessage(response?.data?.message, 'error');
        }
      })
  };


  getDeleteResponse = () => {
    const { late_payment, deleteItem } = this.state
    const updatedAttachments = late_payment?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      late_payment: {
        ...prevState.late_payment,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  render() {
    const { modal, formSubmitLoader, mode, late_payment, error, pageLoader, previewDocs, deleteAttachmentModal } = this.state;
    const { id, m, contractInfo } = this.props;
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getLatePaymentApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} /></Tooltip></span> :
          (contractInfo?.hdlineInfo?.archived_asset == false ?
            <Button onClick={() => this.setState({ modal: true, late_payment: addLatePayment, mode: 'add' })} variant="contained" color="primary"><AddIcon style={{fontSize: '1.15rem'}} />Add Late Payment Interest </Button>
            : null)
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', late_payment: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Late Payment Interest`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctlatepaymentinterest/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      {contractInfo?.hdlineInfo?.archived_asset == false ? checkPermission('contracts','late_payment_interest', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span> : false}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{ position: "sticky" }}>
                <Grid container spacing={3}>
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Component" value={late_payment?.name ? late_payment.name : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="name"
                          label="Name"
                          fullWidth
                          margin="normal"
                          value={late_payment?.name || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'name', e.target.value)}
                          error={error.name ? true:false }
                          helperText={error.name ? error.name: ''}
                          onFocus={(e) => this.updateErrorField('name', '')}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Interest Index" value={late_payment?.interest_index ? late_payment.interest_index : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="interest_index"
                          label="Interest Index"
                          fullWidth
                          margin="normal"
                          value={late_payment?.interest_index || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'interest_index', e.target.value)}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Margin(%)" value={late_payment?.margin ? late_payment.margin : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="margin"
                          label="Margin(%)"
                          fullWidth
                          margin="normal"
                          value={late_payment?.margin || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => regexConstants.numberWithDot.test(e.target.value)?this.onFieldChange(e, 'margin', e.target.value):e.preventDefault()}
                          error={error.margin ? true : false}
                          helperText={error.margin ? error.margin : ''}
                          onFocus={(e) => this.updateErrorField('margin', '')}
                        />
                      </Grid>
                    }
                    {mode === 'view' ?
                      <LabelValueCard md={12} label="Description" value={late_payment?.description ?  <span dangerouslySetInnerHTML={{ __html: late_payment?.description.replace(/\n/g, '<br />') }} /> : '--'} /> :
                      <Grid item xs={12}>
                        <TextField
                          id="description"
                          label="Description"
                          fullWidth
                          multiline
                          rows={4}
                          margin="normal"
                          value={late_payment?.description || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.onFieldChange(e, 'description', e.target.value)}
                        />
                      </Grid>
                    }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) {late_payment?.attachments?.length > 0 ? `[Count : ${late_payment?.attachments?.length}]` : null}</p>
                      {late_payment?.attachments?.length ? late_payment?.attachments && late_payment?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px' }}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '20px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={late_payment}
                          attachedDoc={this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {late_payment?.attachments && late_payment?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px' }}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file }) }}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditRelatedLoanFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    {formSubmitLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save Changes'}
                  </Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', late_payment: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
        {
          this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null
        }
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem, this.toggleFnc, this.getDeleteResponse)}
          /> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(LatePaymentCRU));
